<template>
    <div>
        <AddToCart v-if="showAddProductModal" :preset="preset" v-on:close="closeAddToCartModal()" v-on:added="onAdded()"/>
        <!-- Новий дизайн: усі картки за зразком піци (bp-pcard); у напоїв і снеків без розміру й додатків (bp-pcard--plain) -->
        <div class="product-box" ref="box" :class="{ 'bp-pcard': $v2, 'bp-pcard--plain': $v2 && !v2Pizza }">
            <!-- Новий дизайн: характеристики піци — бейджі з іконками в нижньому лівому куті фото -->
            <div class="bp-photo" v-if="$v2">
                <!-- Піца без фото (у даних заглушка з логотипом) — макет піци замість логотипа.
                     loading="lazy": меню одним гортанням, без нього сторінка тягнула всі ~70 фото (5,6 МБ) одразу;
                     місце під фото тримає aspect-ratio у .bp-photo, тож нічого не стрибає -->
                <img :src="noPhoto ? pizzaMock : product.thumbnail" :alt="product.title" class="product-box-image" :class="{ 'bp-nophoto': noPhoto }" loading="lazy" decoding="async">
                <span v-if="noPhoto" class="bp-nophoto-note"><img :src="$store.state.nightMode ? logoWhite : logo" alt="Black Pizza"><span>Фото незабаром</span></span>
                <span class="bp-tags" v-if="tags.length">
                    <span v-for="tag in tags" :key="tag.key" :class="'bp-tag bp-tag--' + tag.key"
                          role="img" :aria-label="tag.label" :title="tag.label" v-html="tag.icon"></span>
                </span>
            </div>
            <img v-else :src="product.thumbnail" :alt="product.title" class="product-box-image">
            <div class="product-box-info">
                <div class="product-box-title" v-html="product.title"></div>
                <!-- Частини ціни окремо: у новому дизайні «від» і «грн» дрібніші за число.
                     На картці піци в новому дизайні — єдина ціна: вибраний розмір разом із додатками -->
                <div class="product-box-price" v-if="v2Pizza"><span class="bp-num">{{ total }}</span><span class="bp-cur"> грн</span></div>
                <div class="product-box-price" v-else><span class="bp-from" v-if="!product.price">від </span><span class="bp-num">{{ product.price ? product.price : product.price_30 }}</span><span class="bp-cur"> грн</span></div>
                <!-- Новий дизайн: вага / об'єм червоним перед складом, як було; перед ними іконка складу -->
                <div class="product-box-description" v-if="$v2"><span v-if="product.description || weightText || volumeText" class="bp-compo"><span v-if="compoIcon" class="bp-compo__ic" v-html="compoIcon"></span><span><span v-if="weightText || volumeText" class="product-box-description__weight">{{ weightText || volumeText }}<template v-if="product.description"> – </template></span>{{ product.description }}</span></span></div>
                <div class="product-box-description" v-else>
                    <span v-if="product.weight_30 > 0 || product.weight_50 > 0" class="product-box-description__weight">{{
                            product.weight_30 ? product.weight_30 : product.weight_50
                        }} г – </span>
                    {{ product.description }}
                </div>

                <!-- Новий дизайн: розмір і швидкі додатки прямо на картці піци (як у застосунку) -->
                <template v-if="v2Pizza">
                    <div class="bp-size" role="group" aria-label="Розмір" v-if="product.show_30 && product.show_50">
                        <button type="button" v-for="s in sizeNames" :key="s" :aria-pressed="size == s ? 'true' : 'false'" @click="setSize(s)">{{ s }}</button>
                    </div>
                    <div class="bp-size bp-size--one" v-else>{{ size }}</div>

                    <div class="bp-addons" v-if="quickIngredients.length">
                        <!-- Як у застосунку: коло й назва, без ціни; ціна додатка входить у ціну піци вище.
                             Дві колонки, рядками зліва направо, як у застосунку -->
                        <div class="bp-chips" role="group" aria-label="Додати до піци" :style="{ '--bp-rows-max': quickRowsMax }">
                            <button type="button" role="checkbox" class="bp-chip" v-for="ingredient in quickIngredients" :key="ingredient.id"
                                    :aria-checked="isQuickSelected(ingredient.id) ? 'true' : 'false'" @click="toggleQuick(ingredient.id)">
                                <span class="bp-chip__box" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M5 12.5l4.5 4.5L19 7.5"/>
                                    </svg>
                                </span>
                                <span class="bp-chip__t">{{ ingredient.title }}</span>
                            </button>
                        </div>
                    </div>
                </template>

                <button class="add-to-card-button" :class="{ 'bp-done': added }" :aria-live="$v2 ? 'polite' : null" @click="showAddToCardModal()">
                    <!-- Новий дизайн: сумка з плюсом зліва від тексту; після додавання 1,2 с «✓ Додано» — однаково для всіх товарів -->
                    <template v-if="$v2 && added">✓ Додано</template>
                    <template v-else-if="$v2"><inline-svg class="bp-btn-ic" src="/img/icons/shopping-cart.svg" width="20" height="20" fill="currentColor" aria-hidden="true"></inline-svg><span>В кошик</span></template>
                    <template v-else>В кошик</template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import AddToCart from '@/components/AddToCart.vue'
import { PIZZA_KINDS, PIZZA_ICONS, pizzaIs } from '@/pizzaKinds'
import { ICONS } from '@/v2icons'
import { sortMainIngredients } from '@/menuSort'
import InlineSvg from 'vue-inline-svg';

// Піца без фото: бліде фото Маргарити (public/img/pizza-nophoto.webp), поверх — лого й «Фото незабаром»
const PIZZA_MOCK = (process.env.BASE_URL || '/') + 'img/pizza-nophoto.webp';

// Інгредієнти для швидких додатків на картках (новий дизайн): один запит на всі картки міста
const quickCache = Vue.observable({ cityId: null, list: [] });
let quickRequest = null;

// Новий дизайн: картка м'яко виринає, коли заходить в екран; картки, що зайшли разом, — по черзі.
// Сам рух у v2.css (.bp-reveal), там же його вимкнено для «менше руху»
let revealObserver = null;

function revealOnScroll(el) {
    if (!el || !('IntersectionObserver' in window)) {
        return;
    }
    if (!revealObserver) {
        revealObserver = new IntersectionObserver(entries => {
            let order = 0;
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }
                entry.target.style.setProperty('--bp-reveal-delay', Math.min(order++, 6) * 60 + 'ms');
                entry.target.classList.add('bp-reveal--in');
                revealObserver.unobserve(entry.target);
            });
        }, { rootMargin: '0px 0px -24px 0px' });
    }
    el.classList.add('bp-reveal');
    revealObserver.observe(el);
}

function loadQuickIngredients() {
    const cityId = JSON.parse(localStorage.getItem('locationCityId'));
    if (quickRequest && quickCache.cityId === cityId) {
        return quickRequest;
    }
    quickCache.cityId = cityId;
    quickCache.list = [];
    quickRequest = axios.get(`${Vue.prototype.SERVER_URL}/api/${cityId}/ingredients`).then(response => {
        if (quickCache.cityId === cityId) {
            quickCache.list = response.data;
        }
    }).catch(() => {
        // Без додатків на картках; наступна картка спробує ще раз
        quickRequest = null;
    });
    return quickRequest;
}

export default {
    components: {
        InlineSvg,
        AddToCart
    },
    name: 'Product',
    props: {
        product: Object,
    },
    data() {
        return {
            showAddProductModal: false,
            icons: ICONS,
            pizzaMock: PIZZA_MOCK,
            logo: require('@/assets/logo_site.webp'),
            logoWhite: require('@/assets/logo_site_white.webp'),
            // Новий дизайн: вибір на картці піци
            sizeNames: ['30 см', '50 см'],
            // Як у вікні AddToCart: без ціни за 30 см — одразу 50 см
            size: this.product.price_30 ? '30 см' : '50 см',
            selectedQuick: [],
            preset: null,
            added: false,
            addedTimer: null,
            scrollY: 0
        }
    },

    computed: {
        // Ті самі ознаки, що й у фільтрі «Гострі / Ситні / …» (pizzaKinds.js); лише для піц
        tags() {
            if (this.product.category_id != 1) return [];
            return PIZZA_KINDS
                .filter(kind => pizzaIs(kind.key, this.product))
                .map(kind => ({ key: kind.key, label: kind.one, icon: PIZZA_ICONS[kind.key] }));
        },

        // Новий дизайн: вага піци (за вибраним розміром) чи снеку, «600 г»
        weightText() {
            if (!(this.product.weight_30 > 0 || this.product.weight_50 > 0)) return '';
            return (this.v2Pizza ? this.sizeWeight : (this.product.weight_30 ? this.product.weight_30 : this.product.weight_50)) + ' г';
        },

        // Об'єм напою з поля volume (мл): «750 мл», «1000 мл».
        // Якщо об'єм уже написано в назві чи описі («1 літр»), не дублюємо
        volumeText() {
            const ml = parseInt(this.product.volume);
            if (!this.$v2 || this.product.is_beverage != 1 || !(ml > 0)) return '';
            if (/\d\s*(л|літр|ml|мл)/i.test((this.product.title || '') + ' ' + (this.product.description || ''))) return '';
            return ml + ' мл';
        },

        v2Pizza() {
            return this.$v2 && this.product.category_id == 1;
        },

        basePrice() {
            return this.size == '30 см' ? this.product.price_30 : this.product.price_50;
        },

        sizeWeight() {
            const weight = this.size == '30 см' ? this.product.weight_30 : this.product.weight_50;
            return weight ? weight : (this.product.weight_30 ? this.product.weight_30 : this.product.weight_50);
        },

        // Ті самі швидкі кнопки, що й у вікні AddToCart, у порядку застосунку (src/menuSort.js)
        quickIngredients() {
            return sortMainIngredients(quickCache.list.filter(ingredient =>
                ingredient.show_main && (this.size == '30 см' || ingredient.available_50) && !(ingredient.is_black && this.product.is_black)));
        },

        noPhoto() {
            return this.v2Pizza && /placeholder/i.test(this.product.thumbnail || '');
        },

        // Іконка перед складом: у піци немає (03.11 власник обрав без значка), напій — стакан, снек — пачки чипсів (файл власника, маска src/assets/snacks-desc.png)
        compoIcon() {
            return this.v2Pizza ? '' : (this.product.is_beverage == 1 ? ICONS.cupSoda : '<i class="bp-ic-snacks"></i>');
        },

        // Рядків додатків для 30 см (їх найбільше): зона додатків не стрибає, коли на 50 см частина зникає
        quickRowsMax() {
            const n = quickCache.list.filter(ingredient => ingredient.show_main && !(ingredient.is_black && this.product.is_black)).length;
            return Math.ceil(n / 2);
        },

        total() {
            let total = parseInt(this.basePrice) || 0;
            this.quickIngredients.forEach(ingredient => {
                if (this.isQuickSelected(ingredient.id)) {
                    total += this.quickPrice(ingredient);
                }
            });
            return total;
        }
    },

    mounted() {
        if (this.v2Pizza) {
            loadQuickIngredients();
        }
        if (this.$v2) {
            revealOnScroll(this.$refs.box);
        }
    },

    beforeDestroy() {
        clearTimeout(this.addedTimer);
        if (revealObserver && this.$refs.box) {
            revealObserver.unobserve(this.$refs.box);
        }
    },

    methods: {
        // Як у вікні: для 50 см додатки вдвічі дорожчі
        quickPrice(ingredient) {
            const price = parseInt(ingredient.price);
            return this.size == '30 см' ? price : price * 2;
        },

        isQuickSelected(id) {
            return this.selectedQuick.indexOf(id) != -1;
        },

        toggleQuick(id) {
            const index = this.selectedQuick.indexOf(id);
            if (index == -1) {
                this.selectedQuick.push(id);
            }
            else {
                this.selectedQuick.splice(index, 1);
            }
        },

        setSize(size) {
            this.size = size;
            if (size == '50 см') {
                // Прибираємо вибрані додатки, яких немає для 50 см
                this.selectedQuick = this.selectedQuick.filter(id => {
                    const ingredient = quickCache.list.find(e => e.id == id);
                    return ingredient && ingredient.available_50;
                });
            }
        },

        showAddToCardModal() {
            // Новий дизайн: вікно отримує розмір і додатки з картки, а після закриття повертаємось до картки
            if (this.v2Pizza) {
                this.preset = {
                    size: this.size,
                    ingredients: this.selectedQuick.filter(id => this.quickIngredients.some(e => e.id == id))
                };
            }
            // Новий дизайн: напої й снеки теж закривають вікно після «В кошик» і показують «Додано» на картці, як піца
            if (this.$v2 && !this.v2Pizza) {
                this.preset = { size: null, ingredients: [] };
            }
            // Новий дизайн: меню одним гортанням — після вікна повертаємось до картки (і напою теж)
            if (this.$v2) {
                this.scrollY = window.pageYOffset;
            }
            window.scrollTo(0, 0);
            let product = JSON.parse(JSON.stringify(this.product));
            this.$store.commit('setCurrentProduct', product);

            document.querySelector('body').style.overflow = 'hidden';
            this.showAddProductModal = true;
        },

        closeAddToCartModal() {
            document.querySelector('body').style.overflow = '';
            this.showAddProductModal = false;
            this.preset = null;
            if (this.$v2) {
                this.$nextTick(() => window.scrollTo(0, this.scrollY));
            }
        },

        // Новий дизайн: після «В кошик» у вікні кнопка картки 1,2 с показує «Додано»
        onAdded() {
            clearTimeout(this.addedTimer);
            this.added = true;
            this.addedTimer = setTimeout(() => {
                this.added = false;
            }, 1200);
        }
    }
}
</script>

<style>
.product-box {
    position: relative;
    overflow: hidden;

    width: 100%;
    max-width: 280px;
    min-width: 280px;
    height: 360px;

    margin-right: 14px;
    margin-bottom: 14px;
    padding: 14px;
    border: 1px solid white;
    border-radius: 8px;
}

.product-box:hover {
    box-shadow: 0 2px 40px 0 rgba(0, 0, 0, .12);
}

.product-box-image {
    width: 100%;
    border-radius: 8px;
}

.product-box-title {
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
}

.product-box-price {
    font-size: 1.2rem;
    font-weight: bold;
    color: #AB2321;
}

.product-box-description {
    margin-top: 7px;

    font-size: 0.8rem;
    text-align: center;
}

.product-box-description__weight {
    color: #AB2321;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
}

.add-to-card-button {
    margin-top: 12px;
    padding: .375rem .75rem;
    border: 1px solid #AB2321;

    background-color: #AB2321;
    color: #fff;
    border-radius: 6px;
}

.product-box-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-height: 160px;
    padding: 4px 14px 14px 14px;

    box-shadow: 0 -5px 15px rgb(255 255 255);
    background: rgba(255,255,255,0.9);
}

@media only screen and (max-width: 1024px) {
    .product-box {
        width: 100%;
        max-width: 100%;
        padding: 0px;
        margin: 0px;
        margin-bottom: 34px;
        border: 1px solid #eee;
    }

    .product-box-image {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    .product-box-info {
        padding-left: 14px;
        padding-right: 14px;
        padding-bottom: 14px;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

.dark {
    .product-box-info {
        box-shadow: 0 -5px 15px #262323;
        background: rgba(38,35,35,0.9);
    }
}
</style>
